import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';

export default class ArchivingProfilesPageHelp extends React.PureComponent {
  render() {
    const {cardProfile} = this.props;
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>
          A scorecard profile can be assigned to a single department or shared between multiple
          departments.
        </p>
        {cardProfile?.scorecards?.size ? (
          <section>
            <p>Each scorecard profile can have one or more scorecards associated with it.</p>
            <p>Click on a scorecards name to edit it's questions or change the question order.</p>
            <p>
              Click on trash icon to remove a scorecard from this profile (the scorecard will still
              exist and be available for use in other profiles, and in analytics).
            </p>
            <p>Click on 'Create Scorecard' to add a new scorecard to this profile.</p>
            <p>Once you are happy with your changes, click "Save".</p>
          </section>
        ) : (
          <p>
            Each scorecard profile can have one or more scorecards associated with it. Click on
            'Create Scorecard' to add the first scorecard to this profile.
          </p>
        )}
      </HelpLink>
    );
  }
}
